<template>
  <div class="pie-chart">
    <canvas id="chart-canvas" width="300" height="300"></canvas>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import 'chartjs-plugin-labels'
  // populationとhouseholdで処理を分ける
  export default {
    name: 'pie-chart',
    props: {
      info: {
        type: Object,
        default: null
      }
    },
    data: function() {
      return {
        data: null,
        populationLabel: ["10代未満","10代","20代","30代","40代","50代","60代","70代以上"],
        popColor: [
                "rgb(148, 191, 165)",
                "rgb(125, 182, 147)",
                "rgb(101, 162, 139)",
                "rgb(75, 144, 133)",
                "rgb(41, 127, 126)",
                "rgb(35, 107, 112)",
                "rgb(39, 88, 100)",
                "rgb(37, 71, 89)",
                "rgb(51, 51, 51)"
          ],
      }
    },
    mounted: function() {
      this.renderChart()
    },
    methods: {
      renderChart() {
        const ctx = document.getElementById('chart-canvas').getContext('2d')
        console.log("確認よう")
        if (!this.calcInfo) {
          console.log("NODATA!!")
          return
        }
        let pieChart = null
        pieChart = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: this.populationLabel,
            datasets: [{
              backgroundColor: this.popColor,
              data: this.calcInfo.population,
            }],
          },
          options: {
            legend: {
              display: false,
              position: 'right'
            },
            plugins: {
              labels: {
                render: function (args) {
                  return args.label;// + ": " + args.value;
                },
                fontColor: '#FFF',
                overlap: 'false',
                position: 'border',
                fontSize: 14,
              }
            },
          },
        });
        console.log("setPieChartStart")
        this.$store.commit('setPieChart', pieChart);
      },
      // タイムスライダー・rangeの変更イベントとheatType_dが変更イベントを切り分けてupdate処理を記述
      updatePieChart(newval, oldval) {
        console.log("UPDATEPIECHART!!")
        const newKey = Object.keys(newval)
        const oldKey = Object.keys(oldval)
        // console.log("前の値")
        // console.log(oldKey)
        // console.log("後の値")
        // console.log(newKey)
        const data = {
          labels: this.populationLabel,
          datasets: [{
            backgroundColor: this.popColor,
            data: this.calcInfo.population,
          }]
        }
        // this.$store.commit('updatePieChartData', data);
        this.$store.commit('updatePieChartData', this.calcInfo.population);
      },
    },
    computed: {
      year () {
        return this.$store.state.year
      },
      calcInfo () {
        const info = this.info
          if(info !== null){
            return {
              "population":[
                parseInt(info["fless10"])+parseInt(info["mless10"]),
                parseInt(info["f10s"])+parseInt(info["m10s"]),
                parseInt(info["f20s"])+parseInt(info["m20s"]),
                parseInt(info["f30s"])+parseInt(info["m30s"]), 
                parseInt(info["f40s"])+parseInt(info["m40s"]),
                parseInt(info["f50s"])+parseInt(info["m50s"]),
                parseInt(info["f60s"])+parseInt(info["m60s"]),
                parseInt(info["fover70"])+parseInt(info["mover70"])
              ]}
          } else {
            console.log("infoがないのでcalcinfoは動きませんよ")
            return {
              "population":[]
            }
          }
      },
    },
    watch: {
      calcInfo: {
        handler: function (newval, oldval) {
          // setData method  =>  calcInfo computed に変更
          this.updatePieChart(newval, oldval)
          this.$store.commit('chgLoadingModalVisible', false)
        },
        deep: true,
      },

      // ここで監視して更新すると，info変数が書き換わる前に発火してしまう
      // infoWindow側でheatType_dを監視してinfoを更新しているため，pieChartで監視しなくても良い
      // heatType_d() {
      //   this.renderChart()
      // }
    }
  }
</script>

<style scoped lang="scss">
.pie-chart {
  margin-top: 30px;
}
</style>

